// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"e1eadaab","647":"7fa252af"}[chunkId] + ".chunk.js";
};